<div *ngIf="alerts.length > 0" [@listAnimation]="alerts.length" class="alert_list" [style.top]="alerts[0].top||'default'">
    <ng-container *ngFor="let item of alerts; let i = index;">
        <div  (click)="deleteAlert(i)" class="alert {{item.color}}" data-alert="{{i}}">
            <!--            <div class="close">-->
            <!--                <img src="../../../assets/styles/img/icons/close.svg" alt="">-->
            <!--            </div>-->
            <span  [innerHTML]="item.message ? item.message : ('OPERATION_ERROR' | translate) "></span>
        </div>
    </ng-container>
</div>
